/** Memory words outside the memory frame's own components: why a memory
 *  waits for review, thing kinds, relations and how a fact reads. */
export default {
  reasonPhase2Quarantine: "Waiting for review",
  reasonReviewRequired: "Needs your confirmation",
  reasonSensitiveReviewRequired: "This looks sensitive",
  reasonConflictReviewRequired: "Conflicts with what I already remember",
  reasonPossibleDuplicate: "Looks like something I already remember",
  reasonCorrectionTargetUncertain: "I am not sure what this corrects",
  reasonLearnedFromWork: "I picked this up from your work",
  reasonPreviouslyRejected: "You removed this before",
  reasonExplicitFact: "You told me this",
  reasonExplicitProfile: "You told me this about yourself",
  reasonExplicitPreference: "You told me to work this way",
  reasonExplicitNamedEntity: "You named this",
  reasonExplicitRememberedProcess:
    "You told me to remember this way of working",
  reasonExplicitCorrection: "You corrected this",
  reasonCredentialRejected: "Looked like a secret, so I did not keep it",
  reasonTemporallyExpired: "This had already expired",
  reasonUserReview: "You reviewed this",
  reasonUserForgotten: "You asked me to forget this",
  reasonSupersededByActivation: "Learned from a later sighting",
  reasonProposalExpired: "Expired before you reviewed it",
  reasonSourceDeleted: "The conversation it came from was deleted",
  reasonModelChanged: "Denker reorganized its memory",
  reasonScopeUncertain: "I am not sure where this applies",
  reasonLowConfidence: "I am not sure I got this right",
  reasonFactNotExplicit: "You did not say this directly",
  reasonInferredEntity: "I inferred this name",
  reasonSingleSourceInference: "I saw this only once",
  reasonBusinessAssertionReviewRequired: "This is a claim about your business",
  reasonProcessReviewRequired: "This is a way of working",
  reasonVerifiedProcessReviewRequired: "A repeated way of working worth saving",
  reasonUnsupportedCandidate: "I could not classify this",
  reasonRepeatedInferredPreference: "You worked this way more than once",
  reasonExplicitScopedBusinessContext: "You told me this about this work",

  kindUserProfile: "You",
  kindPerson: "Person",
  kindCompany: "Company",
  kindProject: "Project",
  kindResource: "App",
  kindAccount: "Account",
  kindDocument: "Document",
  kindConcept: "Topic",
  kindCategory: "Category",
  kindThing: "Thing",

  wordUserProfile: { one: "profile", other: "profiles" },
  wordPerson: { one: "person", other: "people" },
  wordCompany: { one: "company", other: "companies" },
  wordProject: { one: "project", other: "projects" },
  wordResource: { one: "app", other: "apps" },
  wordAccount: { one: "account", other: "accounts" },
  wordDocument: { one: "document", other: "documents" },
  wordConcept: { one: "topic", other: "topics" },
  wordCategory: { one: "category", other: "categories" },
  wordThing: { one: "thing", other: "things" },
  bundle: "{count} {kind}",
  bundleMore: "{count} more {kind}",

  you: "You",

  relationWorksOn: "works on",
  relationWorksAt: "works at",
  relationBelongsTo: "belongs to",
  relationPrefers: "prefers",
  relationHasGoal: "has goal",
  relationHasDecision: "has decision",
  relationHasHypothesis: "has hypothesis",
  relationDecided: "decided",
  relationBuiltWith: "built with",
  relationTracksWorkIn: "tracks work in",
  relationBillsWith: "bills with",
  relationKeepsNotesIn: "keeps notes in",
  relationInvestedIn: "invested in",
  relationDesigns: "designs",
  relationDescribes: "describes",
  relationOwns: "owns",
  relationDependsOn: "depends on",
  relationAffects: "affects",
  relationTrackedIn: "tracked in",
  relationUses: "uses",
  relationCovers: "covers",
  relationDocumentedIn: "documented in",
  relationMentions: "mentions",
  relationWrote: "wrote",

  inverseWorksOn: "Worked on by",
  inverseWorksAt: "Works here",
  inverseBelongsTo: "Includes",
  inversePrefers: "Preferred by",
  inverseHasGoal: "Goal of",
  inverseHasDecision: "Decision of",
  inverseHasHypothesis: "Hypothesis of",
  inverseDecided: "Decided by",
  inverseBuiltWith: "Builds",
  inverseTracksWorkIn: "Tracks work for",
  inverseBillsWith: "Bills for",
  inverseKeepsNotesIn: "Keeps notes for",
  inverseInvestedIn: "Investors",
  inverseDesigns: "Designed by",
  inverseDescribes: "Described by",
  inverseOwns: "Owned by",
  inverseDependsOn: "Needed by",
  inverseAffects: "Affected by",
  inverseTrackedIn: "Tracks",
  inverseUses: "Used by",
  inverseCovers: "Covered by",
  inverseDocumentedIn: "Documents",
  inverseMentions: "Mentioned in",
  inverseWrote: "Written by",
  inverseUnknown: "{relation} (from)",

  statusGoal: "Goal",
  statusDecision: "Decision",
  statusHypothesis: "Hypothesis",
  statusLine: "{status} · {scope}",
  scopeIn: "in {places}",
  scopeWhen: "when {activities}",
  scopeFor: "for {audiences}",
  appliesTo: "Applies {phrases}",
  appliesEverywhere: "Applies everywhere",
  listSeparator: ", ",
  qualifierWhen: "When {name}",
  qualifierFor: "For {name}",
  qualifierIn: "In {name}",

  profileRole: "Role",
  profileFocus: "Focus",
  profileAudience: "Audience",
  profileWorkingStyle: "Working style",
  profileWebsite: "Website",
  procedureYourChanges: "Your changes",
} as const;
